import BoxIcon from "../../box-icon/box-icon";
import "./card-check-list.scss";

type CardCheckListPropsT = {
  title: string;
  text: string;
  icon: string | number;
  type: "primary" | "secondary";
  elements: string[];
  maxWidth?: string;
  maxHeight?: string;
};

const CardCheckList = ({
  title,
  text,
  icon,
  type,
  elements,
  maxWidth,
  maxHeight,
}: CardCheckListPropsT) => {
  const elementList = elements.map((el: string, index: number) => (
    <li key={`${index}-${el}`} className="card-check-list__list-element">
      {el}
    </li>
  ));

  return (
    <div
      className="card-check-list"
      style={{ maxWidth: maxWidth, maxHeight: maxHeight }}
    >
      <div className="card-check-list__icon">
        <BoxIcon icon={icon} size="medium" type={type} />
      </div>
      <h3 className="card-check-list__title">{title}</h3>
      <p className="card-check-list__text">{text}</p>
      <ul>{elementList}</ul>
    </div>
  );
};

export default CardCheckList;
